import React, { useContext } from 'react';
import { ApLoaderDefault } from '@alixpartners/ui-components';
import { CardText, CardValue, KpiCard } from './KpiList.styles';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';

const KpiElement = ({ cardTitle, value, isLoading }) => {
	return (
		<KpiCard>
			{isLoading ? (
				<ApLoaderDefault />
			) : (
				<>
					<CardValue>{value}</CardValue>
					<CardText>{cardTitle}</CardText>
				</>
			)}
		</KpiCard>
	);
};

const KpiList = () => {
	const { kpi } = useContext(CategoryManagementContext);
	const { isLoading, data } = kpi;
	return (
		<>
			<KpiElement
				cardTitle="Total Spend"
				value={data.totalSpend}
				isLoading={isLoading}
			/>
			<KpiElement
				cardTitle="Total Suppliers"
				value={data.totalSuppliers}
				isLoading={isLoading}
			/>
			<KpiElement
				cardTitle="Business Unit"
				value={data.businessUnit}
				isLoading={isLoading}
			/>
			<KpiElement
				cardTitle="Cost Centers"
				value={data.costCenters}
				isLoading={isLoading}
			/>
			<KpiElement
				cardTitle="Avg Vendor Spend"
				value={data.avgVendorSpend}
				isLoading={isLoading}
			/>
			<KpiElement
				cardTitle="Countries"
				value={data.country}
				isLoading={isLoading}
			/>
			<KpiElement
				cardTitle="Top 80% Vendor Count"
				value={data.vendorCount}
				isLoading={isLoading}
			/>
		</>
	);
};

export default KpiList;
